<template>
  <v-container fluid>
    <main-header-plat-a />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-overlay-loader />
    <v-row class="d-flex justify-center mx-auto" style="width: 95%">
      <v-card style="width: 96%" flat>
        <v-card-subtitle class="mt-2 text-subtitle-1 font-weight-medium">
          Trastornos y/o Problemas Psicológicos
        </v-card-subtitle>
        <v-card-text class="mt-n3 pb-0 ml-1">
          Indicar el nivel de especialización y/o experiencia que tiene como profesional.
        </v-card-text>
        <v-card-text style="min-height: 380px">
          <v-crud
            :headersCrud="schema.headersCrud"
            :editedItems="schema.editedItems"
            :defaultItems="schema.defaultItems"
            :formCrud="schema.formCrud"
            :dataCrud.sync="dataCrud"
            :handleEvents="handleEvents"
            :clickRowInfo="clickRowInfo"
            :remove="remove"
            :observerHCP="observerHCP"
          />
          <span class="d-flex justify-start mt-1 text-body-2">
            *Especialidad (Esp.): Curso de especialidad culminada es considerado un nivel >=6.
            <br />
            *Experiencia (Exp.): Más de 3 años diagnosticando o tratando es considerado un nivel
            >=6.
          </span>
        </v-card-text>
        <v-banner-action-form :save="save" :nextPage="schema.nextPage" />
        <v-snack-bar :snackbar="snackbar" />
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';
import VCrud from '@/components/base/VCrud.vue';
import VBannerActionForm from '@/components/base/VBannerActionForm.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'ProProfileCPage',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
    VOverlayLoader,
    VCrud,
    VBannerActionForm,
    VSnackBar,
  },
  data() {
    return {
      menu: false,
      modal: false,
      menu2: false,
      observerHCP: false,
    };
  },
  mounted() {
    this.loadSchema();
    this.loadDataCrud();
  },
  computed: {
    ...mapGetters('proProfileCPage', ['schema', 'status']),
    ...mapGetters('notifications', ['snackbar']),

    dataCrud: {
      get() {
        return this.$store.state.proProfileCPage.dataCrud;
      },
      set(value) {
        this.$store.commit('proProfileCPage/SET_DATA_CRUD', value);
      }
    }
  },
  methods: {
    ...mapActions('proProfileCPage', ['loadSchema', 'loadDataCrud']),
    ...mapActions('notifications', ['triggerSnackbar']),

    handleEvents() {},

    clickRowInfo(clickItem) {
      this.profesSpecId = clickItem.profes_spec_id;
    },
    
    async save() {
      const model = this.dataCrud;
      this.$store.dispatch('proProfileCPage/save', model).then(
        () => {
          this.reload();
          this.snackbarOpen();
        },
        () => {
          this.reload();
          this.snackbarOpen();
        }
      );
    },
    async remove() {
      let id = this.profesSpecId;
      this.$store.dispatch('proProfileCPage/remove', id).then(
        () => {
          this.reload();
          this.snackbarOpen();
        },
        () => {
          this.reload();
          this.snackbarOpen();
        }
      );
    },
    reload() {
      this.loadDataCrud();
    },
    snackbarOpen() {
      this.snackbar.visible = false;
      if (this.status === 'success') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackOk;
      } else if (this.status === 'removed') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackOkRemoved;
      } else if (this.status === 'error') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackError;
      }
    },
  },
};
</script>
